import { PcTemplateItem } from "@/types";

export const getDefaultPptxCustomization = (
  templates: PcTemplateItem[]
): string => {
  if (templates.length === 0) return "standard";
  if (templates.length === 1) return `pc_template:${templates[0].id}`;
  const primary = templates.find((template) => template.is_primary);
  if (primary) return `pc_template:${primary.id}`;
  return `pc_template:${templates[0].id}`;
};
